import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["quantity", "price", "total"]

  calculate() {
    const quantity = this._parseNumber(this.quantityTarget.value)
    const price = this._parseNumber(this.priceTarget.value)
    const total = quantity * price

    this.totalTarget.value = total.toFixed(2).replace(".", ",")
    this.element.dispatchEvent(new CustomEvent("calculator:updated", { detail: { total }, bubbles: true }))
  }

  _parseNumber(str) {
    if (!str) return 0
    return parseFloat(str.replace(/\./g, "").replace(",", ".")) || 0
  }
}
